module.exports = __webpack_public_path__ + "static/media/Approval.50355923.svg";